/**
 * Permission predicate — does the caller own this federation?
 *
 * Accepts any shape with a `mainManager?: { id }` field — works equally with the
 * GraphQL-derived `Organization & OrganizationWithManagers` and the REST-derived
 * `AvailablePlatformOwner` / `AvailableFederation`. Identity-only — never reads
 * email / phone / personal columns.
 */
export const isFederationOwner = (
  user: { id: string },
  federation: { mainManager?: { id: string } | null } | null
) => {
  return federation?.mainManager?.id === user.id;
};
